import React from "react";

const KPIContainer = ({ title = "", value = "", icon = "" }) => {
  return (
    <div className="flex-1 bg-primary p-4 h-[108px] border-[0.5px] border-light-grey rounded-md">
      <div className="flex items-center gap-x-2.5">
        <div className="w-[38px] h-[38px] flex items-center justify-center rounded-full bg-primary-50">
          {icon}
        </div>

        <p className="font-aileron font-normal text-xs text-light-grey">
          {title}
        </p>
      </div>

      <p className="ml-12 font-poppins font-semibold text-2xl leading-[100%] text-background-white">
        {value}
      </p>
    </div>
  );
};

export default KPIContainer;
